<section class="prose mx-auto px-4 py-6">
	<h5 class="text-center">
		<b>
			TERMO DE CONSENTIMENTO PARA TRATAMENTO DE DADOS PESSOAIS LEI GERAL DE
			PROTEÇÃO DE DADOS PESSOAIS – LGPD PARA OS PROJETOS DE PRÉ-INCUBAÇÃO E
			PRÉ-ACELERAÇÃO NA TXM METHODS E COCREATIONLAB
		</b>
	</h5>
	<p>
		Através do presente instrumento, o qual DOU O ACEITE, com os dados
		registrados na presente Plataforma, e a partir daqui denominado (a) como
		TITULAR, venho por meio deste, AUTORIZAR que a empresa TXM METHODS LTDA -
		ME, aqui denominada como CONTROLADORA, inscrita no CNPJ sob n°
		34.646.446/0001-00, em razão do contrato de trabalho, disponha dos meus
		dados pessoais e dados pessoais sensíveis, de acordo com os artigos 7° e 11
		da Lei n° 13.709/2018, conforme disposto neste termo:
	</p>
	<p>
		<b>CLÁUSULA PRIMEIRA - Dados Pessoais</b><br />
		O Titular autoriza a Controladora a realizar o tratamento, ou seja, a utilizar
		os seguintes dados pessoais, para os fins que serão relacionados na cláusula
		segunda: <br />
		– Nome completo;<br />
		– Data de nascimento;<br />
		– Número e imagem da Carteira de Identidade (RG);<br />
		– Número e imagem do Cadastro de Pessoas Físicas (CPF);<br />
		– Número e imagem da Carteira Nacional de Habilitação (CNH) (quando necessário
		para a função contratada);<br />
		– Endereço completo;<br />
		– Números de telefone, WhatsApp e endereços de e-mail;<br />
		–Comunicação, verbal e escrita, mantida entre o Titular e o Controlador.<br
		/>
	</p>
	<p>
		<b>CLÁUSULA SEGUNDA - Finalidade do Tratamento dos Dados</b><br />
		O Titular autoriza que a Controladora utilize os dados pessoais e dados pessoais
		sensíveis listados neste termo para as seguintes finalidades: – Permitir que
		a Controladora identifique e entre em contato com o titular;<br />
		– Para cumprimento de obrigações decorrentes da legislação;<br />
		– Para cumprimento, pela Controladora, de obrigações impostas por órgãos de fiscalização;<br
		/>
		– Quando necessário para a executar ações relacionadas ao Programa de Pré-Incubação;<br
		/>
		– A pedido do titular dos dados;<br />
		– Para o exercício regular de direitos em processo judicial, administrativo ou
		arbitral;<br />
		– Para a proteção da vida ou da incolumidade física do titular ou de terceiros;<br
		/>
		– Quando necessário para atender aos interesses legítimos do controlador ou de
		terceiros, exceto no caso de prevalecerem direitos e liberdades fundamentais
		do titular que exijam a proteção dos dados pessoais.
	</p>
	<p>
		Parágrafo Primeiro: Caso seja necessário o compartilhamento de dados com
		terceiros que não tenham sido relacionados nesse termo ou qualquer alteração
		posterior, será ajustado novo termo de consentimento para este fim (§ 6° do
		artigo 8° e § 2° do artigo 9° da Lei n° 13.709/2018).
	</p>
	<p>
		Parágrafo Segundo: Em caso de alteração na finalidade, que esteja em
		desacordo com o consentimento original, a Controladora deverá comunicar o
		Titular, que poderá revogar o consentimento, conforme previsto na cláusula
		sexta.
	</p>
	<p>
		<b>CLÁUSULA TERCEIRA - Compartilhamento de Dados</b><br />
		A Controladora fica autorizada a compartilhar os dados pessoais do Titular com
		outros agentes de tratamento de dados, caso seja necessário para as finalidades
		listadas neste instrumento e para as ações de Pré-Incubação, desde que, sejam
		respeitados os princípios da boa-fé, finalidade, adequação, necessidade, livre
		acesso, qualidade dos dados, transparência, segurança, prevenção, não discriminação
		e responsabilização e prestação de contas.
	</p>
	<p>
		<b>CLÁUSULA QUARTA - Responsabilidade pela Segurança dos Dados</b><br />
		A Controladora se responsabiliza por manter medidas de segurança, técnicas e
		administrativas suficientes a proteger os dados pessoais do Titular e à Autoridade
		Nacional de Proteção de Dados (ANPD), comunicando ao Titular, caso ocorra algum
		incidente de segurança que possa acarretar risco ou dano relevante, conforme
		artigo 48 da Lei n° 13.709/2020.
	</p>
	<p>
		<b>CLÁUSULA QUINTA - Término do Tratamento dos Dados</b><br />
		À Controladora, é permitido manter e utilizar os dados pessoais do Titular durante
		todo o período contratualmente firmado para as finalidades relacionadas nesse
		termo e ainda após o término da contratação para cumprimento de obrigação legal
		ou impostas por órgãos de fiscalização, nos termos do artigo 16 da Lei n° 13.709/2018.
	</p>
	<p>
		<b>CLÁUSULA SEXTA - Direito de Revogação do Consentimento</b><br />
		O Titular poderá revogar seu consentimento, a qualquer tempo, por e-mail ou por
		carta escrita, conforme o artigo 8°, § 5°, da Lei n° 13.709/2020. O Titular fica
		ciente de que a Controladora poderá permanecer utilizando os dados para as seguintes
		finalidades:<br />
		– Para cumprimento de obrigações decorrentes da legislação;<br />
		– Para cumprimento, pela Controladora, de obrigações impostas por órgãos de fiscalização;<br
		/>
		– Para o exercício regular de direitos em processo judicial, administrativo ou
		arbitral;<br />
		– Para a proteção da vida ou da incolumidade física do titular ou de terceiros;<br
		/>
		– Quando necessário para atender aos interesses legítimos do controlador ou de
		terceiros, exceto no caso de prevalecerem direitos e liberdades fundamentais
		do titular que exijam a proteção dos dados pessoais.
	</p>
	<p>
		<b>CLÁUSULA SÉTIMA - Tempo de Permanência dos Dados Recolhidos</b><br />
		O titular fica ciente de que a Controladora deverá permanecer com os seus dados
		pelo período mínimo de guarda de documentos mesmo após o encerramento do vínculo
		empregatício.
	</p>
	<p>
		<b
			>CLÁUSULA OITAVA - Vazamento de Dados ou Acessos Não Autorizados –
			Penalidades</b
		><br />
		As partes poderão entrar em acordo, quanto aos eventuais danos causados, caso
		exista o vazamento de dados pessoais ou acessos não autorizados, e caso não haja
		acordo, a Controladora tem ciência que estará sujeita às penalidades previstas
		no artigo 52 da Lei n° 13.709/2018.
	</p>
	<i>Florianópolis/SC, 21 de junho de 2021.</i>
</section>
<section class="prose mx-auto pb-6 prose-li:list-none">
	<h5 class="text-center font-bold">
		TERMO DE COMPROMETIMENTO - CONTRATO TXM METHODS
	</h5>
	<p>
		Contrato a ser celebrado entre os membros do projeto pré-incubado,
		denominados PARTICIPANTES e a empresa TXM METHODS.
	</p>
	<p>
		A empresa TXM Methods Ltda, CNPJ 34.646.446/0001-00, representada neste ato
		por LÚCIA CRISTIANA RIBAS GOMEZ, inscrita no CPF sob o número
		017.349.019-00, doravante denominada executora. Pelo presente instrumento, o
		responsável e os demais membros da equipe do Projeto referenciado neste
		formulário, denominados participantes, declaram-se cientes do conteúdo
		abaixo transcrito:
	</p>
	<ul>
		<li>
			<b> 1. DO OBJETIVO </b>
			<ul>
				<li>
					1.1 O presente termo tem como objetivo regular os direitos e
					obrigações da relação entre o TXM Methods e os projetos selecionados
					no edital de ingresso do Programa CocreationLab Abadeus, executado
					pela TXM Methods.
				</li>
			</ul>
		</li>

		<li>
			<b> 2. DAS CONDIÇÕES PARA PERMANÊNCIA NO ESPAÇO TXM METHODS </b>
			<ul>
				<li>
					2.1 O projeto aprovado poderá usufruir do espaço físico e digital da
					TXM Methods e seus benefícios pelo prazo de 05 (cinco) meses, podendo
					ser prorrogado por mais 02 meses;
				</li>
				<li>
					2.2 Ao final do processo de pré-incubação, o pré-incubado será
					avaliado, obrigatoriamente, através de um relatório elaborado pela
					equipe TXM Methods, onde constarão todas as atividades que foram
					apresentadas e da apresentação do modelo de negócio (pitch) que será
					submetido a avaliação da Comissão da TXM Methods;
				</li>
				<li>
					2.3 Havendo desistência do projeto selecionado no edital de ingresso
					no Programa CocreationLab Abadeus, executado pela TXM Methods, poderão
					ser convocados projetos presentes na lista de espera, obedecendo a
					ordem de classificação, para substituição;
				</li>
				<li>
					2.4 Os Participantes deverão cumprir a carga mínima de 20 horas
					semanais por equipe, seja de forma presencial ou online e a ausência
					maior que 25% dos participantes de um projeto, sem justificativa
					aprovada pela equipe da TXM Methods, implica no seu desligamento
					automático;
				</li>
				<li>
					2.5 A ausência em duas atividades consecutivas ou quatro atividades
					alternadas, dos participantes de um projeto, sem justificativa,
					implica a sua desligamento automático - considerando “atividade” todo
					evento programado no calendário do TXM Methods: palestras (webinar),
					oficinas (workshop), mentorias, etc.
				</li>
				<li>
					2.6 Os participantes devem obrigatoriamente preencher a plataforma
					TXM.Business de forma recorrente, devendo apresentar um preenchimento
					de no mínimo 70% das ferramentas até o ato da realização da terceira
					avaliação (monitoramento 2).
				</li>
				<li>
					2.7 O descumprimento das normas de convivência e utilização do espaço,
					pelos participantes, implica o desligamento automático do seu projeto;
				</li>
				<li>
					2.8 Os participantes se responsabilizarão por todas as informações
					contidas no projeto apresentado, assumindo solidariamente a
					responsabilidade pela sua autoria, permitindo que a TXM Methods, em
					qualquer momento, possa confirmar a veracidade das informações
					prestadas;
				</li>

				<li>
					2.9 As instituições promotoras e parceiras da TXM Methods ficam
					isentas de qualquer responsabilidade pela divulgação não autorizada ou
					obtenção, por terceiros, de informações sobre os projetos divulgados,
					sendo que os participantes abdicam de toda e qualquer reclamação ou
					reivindicação posterior relativa a TXM Methods.
				</li>
			</ul>
		</li>

		<li>
			<b> 3. DO USO DO ESPAÇO FÍSICO </b>
			<ul>
				<li>
					3.1 A TXM Methods funcionará de segunda à sexta-feira conforme regime
					de horários a ser estabelecido semestralmente, a partir de pesquisa de
					interesse realizada com os participantes e disponibilidade do time. As
					atividades oferecidas para fortalecimento dos projetos terão
					calendário divulgado, sendo previstas no mínimo quatro atividades por
					mês, ficando a critério da Gestão o agendamento das mesmas.
				</li>
				<li>
					3.2 São obrigações dos participantes:
					<ul>
						<li>
							a) Zelar pelo patrimônio, entregando o espaço nas mesmas condições
							recebidas;
						</li>
						<li>
							b) Não interferir na estrutura física do prédio, mesmo que
							provisória, com furos, colocação de pregos ou qualquer outro
							objeto nas paredes, pisos, teto, janelas, portas, móveis ou
							qualquer local;
						</li>
						<li>
							c) Refazer a disposição de móveis e objetos que tenham sido
							mudados de lugar; os ambientes devem ser devolvidos com a
							conformação encontrada;
						</li>
						<li>
							d) Circular única e exclusivamente nos espaços autorizados
							oficialmente;
						</li>
						<li>
							e) Respeitar a legislação vigente quanto ao uso de sonorização
							respeitando os níveis máximos de intensidade fixados e horários
							permitidos;
						</li>
						<li>
							f) Entregar o ambiente limpo e organizado, nas mesmas condições em
							que foi recebido;
						</li>
						<li>
							g) Repor e providenciar reparos a qualquer dano da estrutura
							física e/ou equipamentos decorrentes da utilização do espaço.
						</li>
					</ul>
				</li>
			</ul>
		</li>

		<li>
			<b> 4. DO USO DA INTERNET </b>
			<ul>
				<li>
					4.1 Conforme a política de uso da Rede, é vedado o uso da internet nas
					seguintes condições:
					<ul>
						<li>
							a) Produção ou transmissão de dados ou materiais considerados
							ilegais de acordo com a legislação brasileira, entre outros, por
							caracterizarem: transgressão dos direito do autor; de proteção à
							criança e ao meio-ambiente; atentado à privacidade ou promoção à
							discriminação racial ou religiosa; veiculação de propaganda
							comercial, política ou religiosa;
						</li>
						<li>
							b) Transmissão de mensagens ou material de propaganda não
							solicitada pelo destinatário;
						</li>
						<li>
							c) Atividades que contribuam para ineficiência ou esgotamento dos
							recursos na rede, sejam eles computacionais, comunicacionais ou
							humanos;
						</li>
						<li>
							d) Atividades que promovam a corrupção ou destruição de dados de
							usuários;
						</li>
						<li>
							e) Atividades que interrompam ou prejudiquem a utilização dos
							Serviços de Rede por outros usuários.
						</li>
					</ul>
				</li>
			</ul>
		</li>

		<li>
			<b> 5. DA DISCRIMINAÇÃO DA EQUIPE </b>
			<ul>
				<li>
					5.1 A equipe atuante no projeto nominado no preâmbulo deste
					instrumento deverá estar descrita no ANEXO I do presente termo.
				</li>
			</ul>
		</li>

		<li>
			<b> 6. DA VIGÊNCIA </b>
			<ul>
				<li>
					6.1 O presente termo de responsabilidade terá vigência mínima de 06
					(seis) meses, a contar da data de sua assinatura.
				</li>
				<li>
					6.2 O presente termo confere os direitos de manutenção dos históricos
					de dados dos projetos e dos participantes por tempo indeterminado
					conforme as finalidades apresentadas no item 9 deste termo.
				</li>
			</ul>
		</li>

		<li>
			<b> 7. DOS REQUISITOS PARA PERMANÊNCIA NA PRÉ-INCUBAÇÃO </b>
			<p>
				Para manter o vínculo com o programa de pré-incubação e estar apto a ser
				certificado, os projetos selecionados por meio deste edital devem
				atender as condições abaixo declaradas:
			</p>
			<ul>
				<li>
					7.1 Acessar a plataforma periodicamente, preenchendo as ferramentas de
					forma gradual durante o período de pré-incubação.
					<ul>
						<li>
							a) O acesso do projeto à plataforma será bloqueado caso ocorra
							inatividade durante 15 dias consecutivos;
						</li>
						<li>
							b) A equipe poderá reivindicar a recuperação do seu acesso por
							meio de justificativa formal encaminhada à equipe de gestão, no
							prazo de até 5 dias úteis após o primeiro bloqueio;
						</li>
						<li>
							c) Em caso de ausência de reivindicação de acesso à plataforma por
							parte da equipe após 20 dias de inatividade o projeto será
							automaticamente desligado, sendo considerado falta de interesse da
							equipe a permanência na pré-incubação;
						</li>
						<li>
							d) A equipe terá direito de revogar o bloqueio do seu acesso à
							plataforma uma única vez. Em caso de reincidência no bloqueio, o
							projeto será desligado após decorridos novamente 15 dias de
							inatividade na plataforma:
						</li>
						<li>
							e) Será considerado inatividade: falta de preenchimento ou
							atualização de ferramentas, não preenchimento de atas de mentoria,
							não acompanhamento da agenda da turma. A realização apenas de
							login na plataforma não será considerada uma atividade;
						</li>
					</ul>
				</li>
				<li>
					7.2 Participar das atividades de capacitação, cocriação e mentorias
					coletivas oferecidas durante o processo de pré-incubação.
					<ul>
						<li>
							a) A ausência da equipe em duas atividades consecutivas sem prévia
							justificativa será passível de advertência;
						</li>
						<li>
							b) A ausência da equipe em três atividades consecutivas sem prévia
							justificativa será passível de desligamento do projeto do programa
							de pré-incubação.
						</li>
					</ul>
				</li>
				<li>
					7.3 Realizar periodicamente encontros de mentoria, podendo ser semanal
					ou quinzenal, com registros de atas de mentoria na plataforma
					TXM.Business;
					<ul>
						<li>
							a) É de responsabilidade do empreendedor fazer contato com o
							mentor selecionado para o projeto assim que definidos e
							comunicados pela equipe de gestão;
						</li>
						<li>
							b) As mentorias devem ocorrer a cada 1 semana ou 15 dias e
							registradas na plataforma.
						</li>
					</ul>
				</li>
				<li>
					7.4 Participar da equipe nas reuniões de diagnóstico inicial,
					monitoramento 1 e monitoramento 2.
					<ul>
						<li>
							a) Os empreendedores são responsáveis por agendar as reuniões com
							os mentores conforme cronograma disponibilizado pela equipe de
							gestão;
						</li>
						<li>
							b) Os empreendedores são os responsáveis por manter a comunicação
							entre mentor e gestão para confirmação de horário das reuniões,
							bem como, eventuais necessidades de reagendamento.
						</li>
						<li>
							c) A não participação da equipe em uma das reuniões de avaliação
							representará o desligamento do projeto no programa de
							pré-incubação.
						</li>
					</ul>
				</li>
				<li>
					7.5 Acessar o chat TXM.Business diariamente para garantir uma
					comunicação periódica com a equipe de gestão sobre a evolução do
					projeto.
				</li>
			</ul>
		</li>

		<li>
			<b> 8. DOS REQUISITOS PARA GRADUAÇÃO NA PRÉ-INCUBAÇÃO </b>
			<p>
				Para ser considerado graduado e receber a certificação do programa de
				pré-incubação, os projetos selecionados por meio deste edital devem
				atender as condições abaixo declaradas:
			</p>
			<ul>
				<li>
					8.1 Participação igual ou superior à 75% nos eventos de capacitação,
					encontros de cocriação e outras atividades realizadas ao longo da
					pré-incubação, considerando aquelas realizadas de forma presencial e
					virtual;
				</li>
				<li>
					8.2 Realização de encontros de mentoria periódicas, podendo ser
					semanal ou quinzenal, com registros de atas de mentoria na plataforma
					TXM.Business;
				</li>
				<li>
					8.3 Participação da equipe nas reuniões de diagnóstico inicial,
					monitoramento 1 e 2;
				</li>
				<li>
					8.4 Alcance de nota final igual ou superior à 3 na avaliação do
					monitoramento 2;
				</li>
				<li>
					8.5 Preenchimento de porcentagem igual ou superior a 70% das
					ferramentas disponíveis na plataforma TXM.Business;
				</li>
				<li>
					8.6 Apresentação do Pitch final perante uma banca de avaliadora
					juntamente aos demais projetos da turma selecionada pelo presente
					edital.
				</li>
			</ul>
		</li>
		<li>
			<b>Parágrafo único</b>
			<p>
				Ao realizar o monitoramento 2, o projeto deve apresentar o preenchimento
				mínimo de 70% das ferramentas disponíveis na plataforma txm.business,
				para estar apto a apresentar o pitch final e, consequentemente, atender
				a todos os requisitos para receber a graduação do programa de
				pré-incubação do Programa Nascer.
			</p>
		</li>
		<li>
			<b> 9 DA DESISTÊNCIA VOLUNTÁRIA </b>
			<ul>
				<li>
					9.1 Caso a equipe, opte de maneira voluntária por interesse particular
					ou de força maior, solicitar o desligamento do projeto programa de
					pré-incubação, a mesma, compromete-se em informar a equipe gestora da
					sua decisão, formalizando o desligamento por meio do termo de
					desligamento voluntário do projeto.
				</li>
				<li>
					9.2 Caso um dos integrantes, opte de maneira voluntária por interesse
					particular ou de força maior, solicitar o desligamento individual da
					equipe participante do programa de pré-incubação, o mesmo,
					compromete-se em informar a equipe gestora da sua decisão,
					formalizando o desligamento por meio do termo de desligamento
					voluntário de integrante.
				</li>
			</ul>
		</li>
		<li>
			<b>10. DA AUTORIZAÇÃO DE USO DE IMAGEM E VOZ</b>
			<p>
				Com a assinatura deste contrato, os participantes autorizam, Gratuita e
				expressamente, de forma não exclusiva, a utilização de sua imagem, nome,
				interpretação e som de voz por TXM Methods, bem como seus parceiros e
				representantes, para uso em obras fotográficas e audiovisuais, podendo a
				imagem, nome, interpretação e som de voz serem veiculados em todo o
				território brasileiro ou em qualquer local do exterior, em todo e
				qualquer material, sem limitação de formato ou suporte, incluindo, mas
				não se limitando, à internet – incluindo redes sociais como Twitter,
				Facebook, Youtube e Instagram –, links patrocinados, plataformas mobile,
				televisão, rádio, painéis eletrônicos, exibições em circuito fechado e
				em quaisquer locais públicos ou privados, como salas de cinema, teatro,
				clubes, festas, feiras, mídia impressa - incluindo revistas, jornais,
				informativos, anuários, folhetos, mala-diretas, folders, flyers,
				panfletos, cartazes, pôsteres, encartes - e quaisquer outros meios de
				comunicação com o público.
			</p>
			<p>
				Por meio desta autorização, renuncia expressamente a qualquer direito de
				exame ou aprovação prévia para a utilização dos materiais produzidos,
				bem como o direito à participação na produção, reprodução, edição e
				adaptação do material fotográfico e audiovisual. Bem como às demais
				pessoas por ela autorizadas, autonomia na execução dos trabalhos, desde
				que para cumprir especificamente o objetivo aqui previsto e desde que
				não importe em injúria ou desprestígio ao nome ou à imagem.
			</p>
			<p>
				Mesmo após o término deste contrato, concorda que a TXM Methods poderá
				utilizar o material produzido à título de portfólio, para inscrição,
				participação e/ou apresentação em editais, concursos, festivais e
				competições em geral, sendo que não receberá qualquer forma de
				remuneração ou restituição decorrente de tal utilização e/ou veiculação.
			</p>
			<p>
				Reconhece que a TXM Methods não poderá ser responsabilizada, de forma
				alguma, por veiculações ou quaisquer tipos de utilizações realizadas por
				terceiros, no Brasil ou exterior, durante ou após o período mencionado
				neste termo e/ou fora do âmbito dele.
			</p>
		</li>

		<li>
			<b> 11. DO SIGILO E CONFIDENCIALIDADE </b>
			<ul>
				<li>
					11.1 Os participantes, por meio da assinatura deste contrato assumem o
					compromisso de manter confidencialidade e sigilo sobre todas as
					informações técnicas e quaisquer outras atividades, seja, diretas ou
					indiretas, oriundas dos projetos pré-incubados no Programa Nascer, ou
					outras turmas de pré-incubação que por ventura venham a se relacionar
					durante e após a participação na pré-incubação executada pela empresa
					TXM Methods Ltda, CNPJ 34.646.446/0001-00, representada neste ato por
					LÚCIA CRISTIANA RIBAS GOMEZ, inscrito no CPF sob o número
					017.349.019-00, com as seguintes observações:
					<ul>
						<li>
							a) não utilizar as informações confidenciais a que tiver acesso,
							para gerar benefício próprio exclusivo e/ou unilateral, presente
							ou futuro, ou para uso de terceiros;
						</li>
						<li>
							b) não efetuar nenhuma gravação ou cópia da documentação
							confidencial a que tiver acesso relacionada ao conteúdo do projeto
							supra nominado, sem prévia autorização;
						</li>
						<li>
							c) não apropriar-se para si ou para outrem de material
							confidencial e/ou sigiloso que venha a ser disponibilizado aos
							participantes deste projeto;
						</li>
						<li>
							d) não repassar o conhecimento das informações confidenciais,
							responsabilizando-se por todas as pessoas que vierem a ter acesso
							às informações, por seu intermédio, e obrigando-me, desta forma, a
							ressarcir a ocorrência de qualquer dano e/ou prejuízo oriundo de
							uma eventual quebra de sigilo das informações fornecidas;
						</li>
						<li>
							e) responsabilizar-me pelo compromisso ora assumido, pelo prazo de
							20 (vinte) anos, que poderá ser prorrogado no interesse da
							preservação sigilosa das informações para a parte interessada,
							pelo período que for mais conveniente, ficando ciente que essa
							obrigação só poderá ser desconsiderada quando ditas informações
							forem formalmente tornadas de conhecimento público.
						</li>
					</ul>
				</li>
				<li>
					11.2 O participante fica, ainda, ciente que com o descumprimento do
					compromisso ora assumido será considerado infrator, podendo acarretar
					as seguintes sanções:
					<ul>
						<li>
							a) responder, em qualquer hipótese, por perdas e danos, na
							proporção que o prejuízo resultar da quebra de sigilo a ser
							aferido por especialista na questão;
						</li>
						<li>
							b) aplicação da pena prevista no art. 154 do Código Penal, pela
							violação de segredo profissional;
						</li>
						<li>
							c) aplicação da pena capitulada no art. 325 do Código Penal, pela
							violação de sigilo funcional, e, concomitantemente, às penalidades
							inerentes aos crimes contra a Administração Pública, se for o
							caso, sem prejuízos das sanções administrativas e civis
							decorrentes das legislações pertinentes;
						</li>
						<li>
							d) outras penalidades previstas e decorrentes da inobservância ou
							oriundas de Tratados e normas de caráter internacional, que sejam
							devidamente reguladas pela lei brasileira.
						</li>
					</ul>
				</li>
				<li>
					11.3 Tenho conhecimento que o compromisso ora assumido é obrigatório e
					intransferível e só poderá ser desconsiderado nas seguintes hipóteses:
					<ul>
						<li>
							a) quando se tratar de informação já conhecida anteriormente às
							tratativas do projeto;
						</li>
						<li>
							b) quando houver prévia e expressa anuência do inventor, quanto a
							liberação da obrigação de sigilo e confidencialidade;
						</li>
						<li>
							c) quando a informação foi comprovadamente obtida por outra fonte,
							de forma legal e legítima, independente do presente instrumento
							jurídico;
						</li>
						<li>
							d) quando autorizada por determinação judicial e/ou governamental
							para seu conhecimento ao autor, desde que notificada imediatamente
							à representação legal destas, previamente à liberação e sendo
							requerido segredo de justiça no seu trato judicial e/ou
							administrativo.
						</li>
					</ul>
				</li>
				<li>
					11.4 O participante compromete-se, ainda, a não divulgar quaisquer
					aspectos ou informações sobre o conteúdo do presente Instrumento, cuja
					divulgação estará adstrita ao prévio conhecimento da TXM Methods.
				</li>
			</ul>
		</li>

		<li>
			<b>12. DO USO E TRATAMENTO DE DADOS</b>
			<ul>
				<li>
					12.1 O participante confirma ter lido e estar de acordo com as
					políticas de privacidade e os termos de uso da TXM Methods, conforme
					consta na página https://www.txm-methods.com/lgpd/ e plataforma de
					acesso exclusivo dos participantes para consulta em qualquer momento.
				</li>
				<li>
					12.2 O participante declara estar ciente de que seus dados e suas
					ideias serão mantidas pela TXM Methods por tempo indeterminado, cuja
					finalidade é acompanhar e dar suporte ao desenvolvimento do projeto,
					bem como, possível compartilhamento com a finalidade de divulgação e
					visibilidade dos negócios pré-incubados e uso para pesquisa e
					melhorias nos processos e serviços oferecidos.
				</li>
				<li>
					12.3 O participante declara estar ciente de que seus dados de contato,
					bem como, o resumo de seus projetos poderão ser compartilhados com
					parceiros, mentores, terceiros e equipes internas e externas de gestão
					da TXM Methods.
				</li>
				<li>
					12.4 O participante isenta a TXM Methods de quaisquer
					responsabilidades e ônus provenientes do mau uso ou inconsistência dos
					dados fornecidos à TXM Methods.
				</li>
				<li>
					12.5 O participante declara estar ciente que a TXM Methods preza pelo
					rigor da Lei Geral de Proteção de Dados, e pela segurança das
					informações disponibilizadas.
				</li>
			</ul>
		</li>

		<li>
			<b
				>13. DAS PARCERIAS ENTRE OS PROJETOS E ENTRE OS PROJETOS E TERCEIROS
				EXTERNOS AO PROGRAMA</b
			>
			<ul>
				<li>
					13.1 A TXM Methods LTDA não se responsabiliza pelas parcerias
					realizadas entre os projetos pré-incubados e pré-acelerados, ou entre
					os referidos projetos e empresas ou pessoas físicas fora da
					Pré-Incubação e Pré-aceleração. A TXM Methods também não se
					responsabiliza pelas relações comerciais, patrimoniais, econômicas,
					financeiras, ou quaisquer outros tipos que sejam realizadas entre os
					projetos pré-incubados e pré-acelerados e parceiros diretos ou
					indiretos da própria TXM Methods, pois entendemos que a liberdade
					contratual é princípio das relações brasileiras, e nosso foco é
					somente na Metodologia de Pré-Incubação e Pré-aceleração para fornecer
					a quem participar destas atividades o conhecimento para tomada de
					decisão, mas nós não nos responsabilizamos pela decisão tomada, que é
					de livre escolha e arbítrio dos membros dos projetos pré-incubados e
					pré-acelerados.
				</li>
			</ul>
		</li>
	</ul>
	<p>
		E, assim, confirmo estar de acordo com as condições do presente contrato,
		depois de lido e achado conforme, concordando com todos os seus termos e
		itens acima relacionados, para que produza seus efeitos legais.
	</p>
</section>

<svelte:head>
	<title>TXM Business | Termo de Consentimento</title>
</svelte:head>
